module.exports = __webpack_public_path__ + "static/img/newmedia2.f8028ff8.png";